import {AnalyticSvc} from '../services/AnalyticSvc';

export class MainLanding {
    constructor(private analyticSvc: AnalyticSvc) {}

    selectProduct(product: AnimatronProduct) {
        this.analyticSvc.selectProduct(product);
    }
}

angular.module('animatronApp.mainLanding', []).component('mainLanding', {
    controller: MainLanding,
    templateUrl: require('landing/main-landing.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/mainLanding.ts